import { mapActions, mapState } from 'vuex';
import loading from '@codehq/aurora-app-core/src/mixins/loading';

export default {
  mixins: [loading],
  data() {
    return {
      stockItemId: this.$route.query.stockItemId,
    };
  },
  computed: {
    /** Vuex states
     */
    ...mapState('stockItems', ['stockItem']),
  },
  async mounted() {
    this.isLoading = true;
    const stockItem = await this.LOAD_stockItem(this.$route.query.stockItemId);
    this.isLoading = false;
    this.$emit('stockItem.loaded', stockItem);
  },
  methods: {
    /** Vuex methods
     */
    ...mapActions('stockItems', ['LOAD_stockItem']),
  },
};
